/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3" v-if="page == 'view-level'">All Levels</h4>
        <h4 class="text-center font-weight-bold py-3" v-if="page == 'add-lesson'">Select Lesson Level</h4>
        <h4 class="text-center font-weight-bold py-3" v-if="page == 'edit-lesson'">Select Lesson Level</h4>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">Title</th>
                        <th scope="col">Take Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="cat in categories" :key="cat._id">
                        <th>{{cat.title}}</th>
                        <td>
                            <router-link :to="{ name: 'EditCategory', params : {categoryId : cat._id} }">
                                <button class="btn btn-primary btn-sm">Edit</button>
                            </router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
export default {
    name: 'Categories',
    components: {

    },
    data() {
        return {
            categories: [],
            page: this.$route.params.page,
            baseUrl: "/categories",
            fastAdminToken : localStorage.getItem("fastAdminToken")
        }
    },
    mounted() {

        this.$toast.open({
            message: "Processing : Loading Levels Please Wait...",
            type: 'info'
        })

        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }

        axios.get(this.$apiURI + this.baseUrl, config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    
                    // eslint-disable-next-line no-console
                    // console.log(response.data.data.teachers)
                    this.categories = response.data.data.categories
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    }
}
</script>
